<template>
    <div class="kit-info__step__product">
        <figure>
            <img :src="product.product.image.full_src" />
        </figure>
        <div>
            <h4>{{ product.product.title }}</h4>

            <ProductAttributes :product="product" />

            <ProductInlineQuantity :step="step" :pid="pid" :on-edit="onEdit" />

            <ProductSettings :step="step" :pid="pid" @change-quantity="editMode" />
        </div>
    </div>
</template>

<script>
    import ProductAttributes from '../product/ProductAttributes.vue';
    import ProductInlineQuantity from '../product/ProductInlineQuantity.vue';
    import ProductSettings from '../product/ProductSettings.vue';

    export default {
        name: 'StepProduct',
        props: ['product', 'step'],
        components: {
            ProductAttributes,
            ProductInlineQuantity,
            ProductSettings
        },
        data() {
            return {
                onEdit: false
            }
        },
        computed: {
            pid() {
                return this.product.variation ? this.product.variation.variation_id : this.product.product.id;
            },
        },
        methods: {
            editMode(mode) {
                this.onEdit = mode;
            }
        }
    }
</script>

<style lang="scss">
        .kit {
            &-info {
                &__step {
                    &__product {
                        border-top: 1px solid #E5E7EC;
                        padding: 10px 8px;
                        display: grid;
                        grid-template-columns: 65px 1fr;
                        gap: 10px;

                        img {
                            width: 100%;
                        }

                        h4 {
                            font-size: 12px;
                            font-weight: 700;
                            line-height: 19.462px;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
</style>